import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'


window.addEventListener('DOMContentLoaded', () => {
    document.getElementsByTagName('BODY')[0].classList.remove('jsdisabled')
    for (const elem of document.getElementsByClassName('topcheckform')) {
        elem.style.display = 'block'
    }

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => {setTimeout(setCMSBarWidth, 1000)}, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))

}, false)
